export enum Service {
  CORONET = "coronet",
  OFFICE_365 = "office365Enforcement",
  DROPBOX = "dropboxEnforcement",
  G_SUITE = "googleDirectoryEnforcement",
  BOX = "boxEnforcement",
  SALES_FORCE = "salesforceEnforcement",
  SLACK = "slackEnforcement",
  PROXY = "emailProxyEnforcement",
  OUTBOUND_PROXY = "outboundEmailProxyEnforcement",
  GOOGLE = "google",
}

export enum CloudAppsRedirectUrl {
  DASHBOARD = "DASHBOARD",
  CLOUD_APPS_SETTINGS = "CLOUD_APPS_SETTINGS",
}

export enum ServiceAction {
  CONNECT = "connectService",
  DISCONNECT = "disconnectService",
  CONNECTION_STATUS = "connectionStatus",
  REMOVE = "removeService",
  GRANT_PRIVILEGES = "grantPrivileges",
  ACCESS_RESTRICTIONS = "accessService",
  NEW_OFFICE_ACCOUNT_ERROR = "newOfficeAccountError",
}

export enum ServiceStatus {
  CONNECTED = "connected",
  CONNECTED_NOT_SECURE = "connectedNotSecure",
  DISCONNECTED = "disconnected",
  INCOMPLETE = "incomplete",
  NOT_CONNECTED = "notConnected",
  ENABLED = "enabled",
}

export enum AppType {
  TEAM_MANAGEMENT_KEY = "teamManagementKey",
  TEAM_FILE_ACCESS_KEY = "teamFileAccessKey",
  DEFAULT = "default",
}

export enum AccessPermissionAction {
  ADD = "addAccessPermissions",
  EDIT = "editAccessPermissions",
  DELETE = "deleteAccessPermissions",
}

export enum ThreatTypeAction {
  ADD = "addThreatType",
  EDIT = "editThreatType",
  DELETE = "deleteThreatType",
}

export enum AccessPermissionType {
  ALL_USERS = "all",
  SPECIFIC_GROUPS = "group",
  SPECIFIC_USERS = "user",
  LABEL = "label",
}

export enum ThirdPartyAppsAction {
  BLOCK_APP = "blockApp",
}

export enum OfficeErrorCode {
  IS_NOT_ADMIN = "notAdmin",
  ACCOUNT_ALREADY_EXIST = "company_already_registered",
  IS_NEW_ACCOUNT = "new_office_account",
  ACCESS_DENIED = "access_denied",
}
